import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { TransactionService } from "../shared/services/transaction.service";
import { ActivatedRoute } from "@angular/router";
import { AdminService } from "../shared/services/admin.service";

import { ExcelService } from "../shared/services/excel.service";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { TopbarComponent } from "../shared/components/topbar/topbar.component";
import { SidebarComponent } from "../shared/components/sidebar/sidebar.component";
import { BottombarComponent } from "../shared/components/bottombar/bottombar.component";
import { TransactionFilterComponent } from "./transaction-filter/transaction-filter.component";
import { NgxPaginationModule } from "ngx-pagination";

@Component({
    selector: "app-transaction",
    templateUrl: "./transactions.component.html",
    styleUrls: ["./transactions.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        RouterModule,
        NgxPaginationModule,
        TopbarComponent,
        SidebarComponent,
        BottombarComponent,
        TransactionFilterComponent,
    ]
})
export class TransactionsComponent implements OnInit {
  showFilter: boolean = false;
  showViewer: boolean = false;
  transactions;
  showLoader: boolean = false;
  selectedTransaction: string;
  agents;
  emptyTransactionMessage: string = "Transaction log is empty.";
  sortType: string;
  sortReverse: boolean = false;
  config: any;
  title;
  details;

  constructor(
    private transactionService: TransactionService,
    private route: ActivatedRoute,
    private adminService: AdminService,
    private excelService: ExcelService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.showLoader = false;
    this.showLoader = false;
    this.getDetails();

    this.route.paramMap.subscribe((params) => {
      const status = params.get("status");
      if (status && status !== "today") {
        const edit = status === "success" ? "Successful" : status;
        this.title = edit + " Transactions";
        this.getTransactionsWithStatus(status);
        console.log(status);
      }
      if (status && status === "today") {
        this.title = "Today's Transactions";
        this.getTransactionsWithStatus("today");
        console.log(status);
      }
      if (!status) {
        this.getAllTransactions();
      }
    });
  }

  onShowFilter() {
    this.showFilter = true;
  }

  onCloseFilter(data) {
    this.showFilter = data;
  }

  getFilteredTransactions(event) {
    this.transactions = event.data;
    this.emptyTransactionMessage = "Filter Result: 0 No matching records.";
  }
  isEmptyTransaction() {
    if (Object.keys(this.transactions).length > 0) {
      return false;
    }
    return true;
  }



  

  exportReports() {
    const reports = [];

    this.transactions.forEach(
      ({
        transaction_ref,
        sender_fullname,
        sender_mobile_number,
        sender_country,
        sender_city,
        sender_email,
        beneficiary_fullname,
        beneficiary_mobile_number,
        beneficiary_country,
        beneficiary_city,
        beneficiary_email,
        beneficiary_bank_name,
        beneficiary_bank_account_number,
        beneficiary_bank_account_name,
        payout_amount,
        payout_currency,
        mode_of_payment,
        status,
        purpose_of_transaction,
        created_at,
        dollar_equivalent,
        dollar_rate,
        amount_sent,
        imto_balance_after
      }) =>
        reports.push({
          created_at,
          transaction_ref: parseFloat(transaction_ref),
          sender_fullname,
          sender_mobile_number: parseFloat(sender_mobile_number),
          sender_country,
          sender_city,
          sender_email,
          beneficiary_fullname,
          beneficiary_mobile_number: parseFloat(beneficiary_mobile_number),
          beneficiary_country,
          beneficiary_city,
          beneficiary_email,
          beneficiary_bank_name,
          beneficiary_bank_account_number: parseFloat(
            beneficiary_bank_account_number
          ),
          beneficiary_bank_account_name: parseFloat(
            beneficiary_bank_account_name
          ),
          payout_amount: parseFloat(payout_amount),
          amount_sent: parseFloat(amount_sent),
          new_imto_balance:
            status === 'success' && imto_balance_after
              ? parseFloat(imto_balance_after)
              : null,
          payout_currency,
          mode_of_payment,
          status,
          purpose_of_transaction,
          dollar_equivalent,
          dollar_rate
        })
    );

    this.excelService.exportAsExcelFile(reports, "icashremit report");
  }

  getAllTransactions() {
    this.transactionService.getAll().subscribe((data) => {
      this.transactions = data;
      this.config = {
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: this.transactions.length,
      };
      this.refresh();
    });
  }

  getTransactionsWithStatus(id) {
    this.transactionService.getTransactionsWithStatus(id).subscribe((data) => {
      this.transactions = data;
      this.config = {
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: this.transactions.length,
      };
      this.refresh();
    });
  }

  refresh() {
    try {
      this.cdr.detectChanges();
    } catch (e) { void e; }
  }

  // Sort
  sortOrders(property) {
    this.sortType = property;
    this.sortReverse = !this.sortReverse;
    this.transactions.sort(this.dynamicSort(property));
  }
  dynamicSort(property) {
    let sortOrder = -1;

    if (this.sortReverse) {
      sortOrder = 1;
    }

    return (a, b) => {
      const result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  pageChanged(event) {
    this.config.currentPage = event;
    this.refresh();
  }

  getDetails() {
    this.adminService.getDetails().subscribe((data) => {
      this.details = data[0];
      this.refresh();
    });
  }

  
}
